import { CloudDownload } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { Minuta, Processo } from '../modelo';
import { VersaoMinutaDto } from '../modelo/dto/VersaoMinutaDto';
import MinutaService from '../services/MinutaService';

interface IPropsDownloadVersaoMinuta {
    versao?: VersaoMinutaDto;
    processo?: Partial<Processo>;
    minuta?: Minuta; 
}

export default class DownloadVersaoMinuta extends React.Component<IPropsDownloadVersaoMinuta> {

    historicoMinutaService = MinutaService;

    downloadVersao = async () => {
        await this.historicoMinutaService.baixarVersaoMinuta(this.props.versao, this.props.minuta.numero, this.props.processo.numeroProcesso);
    }

    render() {
        return (
                <>
                    <Tooltip placement='bottom' title={ "Baixar versão"} >
                        <IconButton id="botaoDownloadMinuta"
                            onClick={this.downloadVersao}
                            style={{ width: '40px', height: '30px', padding: '0px' }}
                            >
                            <CloudDownload />
                        </IconButton > 
                    </Tooltip>
                </>
        );
    }
}
